import React, { FC } from "react";
import { Row, Col, Card, Progress } from "antd";
import "./progress-card.scss";
import CustomTooltip from "@pages/tool-tip";
import { getProgressColorCode } from "@pages/utils/utils";

const NonCanonicalRisk: FC<any> = (props) => {
  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{ margin: "8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );
  return (
    <Col span={props.size}>
      <Card style={{ height: props.cardHeight }} className="progress-card">
        <Row>
          <Col span={10}>
            <Row>
              <Col span={24} style={{ height: (props.cardHeight * 2) / 10 }}>
                {getHeading("Non Clinical Risk")}
              </Col>

              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: (props.cardHeight * 5) / 10,
                }}
                span={24}
              >
                <Progress
                  type="circle"
                  percent={props?.value?.sdohAndA2c ? props?.value?.sdohAndA2c : 0}
                  strokeColor={getProgressColorCode(props?.value?.sdohAndA2cRiskFlag)}
                  format={(percent)=> { return <span style={{color : "#7A869A"}}>{percent+ ' %' }</span>}}
                />
              </Col>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: (props.cardHeight * 1) / 10,
                }}
                span={24}
              >
                <span style={{ color: "#b3bac5", fontSize: "14px" }}>
                  {props.percent}
                </span>
              </Col>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "center",
                  height: (props.cardHeight * 1) / 10,
                }}
                span={24}
              >
                <span style={{ color: "#42526e", fontSize: "14px" }}>
                  {"SDoH + A2C"}
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={14} style={{ marginTop: 55 }}>
            <Card style={{ height: props.cardHeight - 120 }}>
              <Row gutter={24}>
                <Col span={12}>
                  <Row>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: ((props.cardHeight - 120) * 6) / 10,
                      }}
                      span={24}
                    >
                      <Progress
                        type="circle"
                        percent={props?.value?.sdoh ? props?.value?.sdoh : 0}
                        strokeColor={getProgressColorCode(props?.value?.sdohRiskFlag)}
                        width={80}
                        format={(percent)=> { return <span style={{color : "#7A869A"}}>{percent+ ' %' }</span>}}
                      />
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: ((props.cardHeight - 120) * 1) / 10,
                      }}
                      span={24}
                    >
                      <span style={{ color: "#b3bac5", fontSize: "14px" }}>
                        {props.percent}
                      </span>
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: (props.cardHeight * 1) / 10,
                      }}
                      span={24}
                    >
                      <span style={{ color: "#42526e", fontSize: "14px" }}>
                        {"SDoH"}
                      </span>
                    </Col>
                  </Row>
                </Col>

                <Col span={12}>
                  <Row>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: ((props.cardHeight - 120) * 6) / 10,
                      }}
                      span={24}
                    >
                      <Progress
                        type="circle"
                        percent={props?.value?.a2cAverage ? props?.value?.a2cAverage : 0}
                        strokeColor={getProgressColorCode(props?.value?.a2cRiskFlag)}
                        width={80}
                        format={(percent)=> { return <span style={{color : "#7A869A"}}>{percent+ ' %' }</span>}}
                      />
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: ((props.cardHeight - 120) * 1) / 10,
                      }}
                      span={24}
                    >
                      <span style={{ color: "#b3bac5", fontSize: "14px" }}>
                        {props.percent}
                      </span>
                    </Col>
                    <Col
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: ((props.cardHeight - 120) * 1) / 10,
                      }}
                      span={24}
                    >
                      <span style={{ color: "#42526e", fontSize: "14px" }}>
                        {"A2C (Average)"}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default NonCanonicalRisk;
